<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      size="auto"
      no-padding
      :content-style="{padding: '16px 30px 4px 20px'}"
      :visible.sync="modalVisible"
      :confirm-loading="confirmLoading"
      @cancel="cancel"
      @confirm="confirm">
    <template #header>
      报价-{{product.name}}
    </template>
    <template #content>
      <div v-if="false">
        <gj-input v-model="labelWidth" />
        <gj-input v-model="label0Width" />
        <gj-input v-model="label1Width" />
        <gj-input v-model="inputWidth" />
        <gj-input v-model="longInputWidth" />
      </div>
      <el-form
          ref="form"
          :model="form"
          :label-width="labelWidth">
        <gj-area-title>基本信息</gj-area-title>
        <el-row>
          <el-col :span="16">
            <el-form-item label="供应商编号/名称">
              {{offer.supplierCode | defaultShow}} / {{offer.name | defaultShow}}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
                label="采购交期"
                prop="purchaseDeliveryDays"
                :label-width="label1Width"
                :rules="[
                  { required: true, message: '请输入采购交期', trigger: ['change'] },
                  $gjReRule(RE.pt, '请输入正整数')
                ]">
              <gj-input
                  v-model="form.purchaseDeliveryDays"
                  :width="inputWidth"
                  :clearable="false"
                  placeholder="采购交期">
                <template #append>天</template>
              </gj-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col v-if="false" :span="16">
            <el-form-item
                label="默认供应商"
                prop="name"
                :rules="[
                  { required: true, message: '', trigger: ['change'] },
                ]">
              <el-radio-group v-model="form.targetingType">
                <el-radio :label="true">是</el-radio>
                <el-radio :label="false">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
                label="最小起订量"
                prop="moq"
                :rules="[
                  $gjReRule(RE.pt, '请输入正整数')
                ]">
              <gj-input
                  v-model="form.moq"
                  :width="inputWidth"
                  :clearable="false"
                  placeholder="不填则为0">
              </gj-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item
            label="产品网址">
          <gj-input
              v-model="form.purchaseUrl"
              :width="longInputWidth">
          </gj-input>
        </el-form-item>
        <gj-area-title>报价信息</gj-area-title>
        <el-row>
          <el-col :span="9">
            <el-form-item
                prop="currency"
                :rules="[
                  { required: true, message: '请输入不含税单价', trigger: ['change'] },
                ]">
              <template #label>
                币种
              </template>
              <gj-select
                  v-model="form.currency"
                  :options="option.currency"
                  :width="inputWidth"
              ></gj-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
                label="实际税率"
                prop="actualTaxRate"
                :rules="[
                  $gjRequired('请输入实际税率'),
                  $gjReRule(RE.num(2), '最多2位小数')
                ]">
              <gj-input
                  v-model="form.actualTaxRate"
                  :width="inputWidth"
                  :clearable="false"
                  placeholder="实际税率">
                <template #append>%</template>
              </gj-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item
                label="票面税率"
                prop="invoiceTaxRate"
                :rules="[
                  $gjReRule(RE.num(2), '最多2位小数')
                ]">
              <gj-input
                  v-model="form.invoiceTaxRate"
                  :width="inputWidth"
                  :clearable="false"
                  placeholder="票面税率">
                <template #append>%</template>
              </gj-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item
                prop="includeTaxPrice"
                :rules="[
                  { required: true, message: '请输入含税单价', trigger: ['change'] },
                  $gjReRule(RE.num(2), '最多2位小数')
                ]">
              <template #label>
                含税单价
              </template>
              <gj-input
                  v-model="form.includeTaxPrice"
                  placeholder="只保留2位小数"
                  :clearable="false"
                  :width="inputWidth"
              ></gj-input>
              <span>（不含税单价：{{form.excludeTaxPrice || 0}}）</span>
            </el-form-item>
          </el-col>
          <el-col v-if="false" :span="8">
            <el-form-item
                label="发票类型"
                prop="name"
                :label-width="label0Width">
              <gj-select
                  v-model="form.name"
                  :width="inputWidth"
                  :options="[]"
                  :clearable="false"
                  placeholder="发票类型"
              ></gj-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </template>
  </gj-modal>
</template>

<script>
  import {modalMixIn, formRuleMixin, responseMixin} from "../../../../../../minxins";
  import {OpEnum} from "../../../../../../utils/options";
  import {toFixed} from "../../../../../../utils/common";
  import {addSupplierQuote} from "../../../../../../api/product";

  export default {
    name: "app-product-offer-modal",
    mixins: [modalMixIn, formRuleMixin, responseMixin],
    props: {
      offer: {
        required: true
      },
      product: {
        required: true
      }
    },
    data() {
      return {
        confirmLoading: false,
        form: {
          supplierQuoteId: null,
          purchaseDeliveryDays: null,
          moq: null,
          purchaseUrl: null,
          currency: null,
          actualTaxRate: null,
          invoiceTaxRate: null,
          excludeTaxPrice: null,
          includeTaxPrice: null
        },
        labelWidth: '110px',
        label0Width: '140px',
        label1Width: '142px',
        inputWidth: '120px',
        longInputWidth: '700px',
        option: {
          currency: [
            {id: 'CNY', text: 'CNY'},
            {id: 'USD', text: 'USD'},
          ]
        }
      }
    },
    created() {
      Object.assign(this.form, this.offer);
      if (this.form.moq === 0) {
        this.form.moq = null;
      }
      this.form.supplierQuoteId = this.offer.id;
    },
    computed: {
      price() {
        return {
          actualTaxRate: this.form.actualTaxRate,
          includeTaxPrice: this.form.includeTaxPrice
        }
      }
    },
    watch: {
      price({actualTaxRate, includeTaxPrice}) {
        if (this.RE.num(4).test(actualTaxRate)
          && this.RE.num(2).test(includeTaxPrice)) {
          this.form.excludeTaxPrice = toFixed(includeTaxPrice / (1 + Number(actualTaxRate) / 100));
        } else {
          this.form.excludeTaxPrice = '-';
        }
      }
    },
    methods: {
      confirm() {
        if (this.$gjFormValidate()) {
          this.confirmLoading = true;
          addSupplierQuote({
            id: this.form.id,
            supplierCode: this.form.supplierCode,
            supplierQuoteId: this.form.supplierQuoteId,
            purchaseDeliveryDays: this.form.purchaseDeliveryDays,
            moq: this.form.moq,
            purchaseUrl: this.form.purchaseUrl,
            currency: this.form.currency,
            actualTaxRate: this.form.actualTaxRate,
            invoiceTaxRate: this.form.invoiceTaxRate,
            excludeTaxPrice: this.form.excludeTaxPrice,
            includeTaxPrice: this.form.includeTaxPrice,
            skus: [this.product.sku],
          })
            .then((res) => {
              this.$gjResponseHandle(res, () => {
                this.$emit('created');
                this.$gjDestroy();
              });
            })
            .complete(() => this.confirmLoading = false);
        }
      }
    }
  }
</script>

<style scoped>

</style>

